import React, { useMemo } from 'react';
import selectedRadio from '../../assets/radio-selected.svg';
import deselectedRadio from '../../assets/radio-deselected.svg';
import deselectedRadioOnyx from '../../assets/radio-onyx-deselected.svg';
import selectedRadioBlue from '../../assets/radio-pc-color-blue-selected.svg';
import './RadioButton.css';

const RadioButton = ({
  blue = false,
  checked = false,
  children,
  className = '',
  id = '',
  name = '',
  onChange = () => { },
  ...inputProps
}) => {
  const img = useMemo(() => {
    if (blue) {
      return checked ? selectedRadioBlue : deselectedRadioOnyx;
    }
    return checked ? selectedRadio : deselectedRadio;
  }, [blue, checked]);
  return (
    // Disabled rule 'cause this structure replace the htmlFor attr
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      className={`Radio-button ${className}`
        + ` ${blue ? 'Radio-button-blue' : ''}`}
    >
      <img
        alt=""
        className="Radio-button-img"
        src={img}
      />

      <input
        id={id}
        name={name}
        onChange={onChange}
        type="radio"
        {...inputProps}
      />

      {children}
    </label>
  );
};

export { RadioButton };
